import * as React from "react";
import type { SVGProps } from "react";
const SvgErrorTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="#BA1F1A"
      fillRule="evenodd"
      d="M19.74 15.05 11.77 1.02C11-.34 9-.34 8.22 1.02L.26 15.05C-.49 16.37.49 18 2.03 18h15.94c1.55 0 2.52-1.63 1.77-2.95M9.24 5c0-.41.34-.74.76-.74s.76.33.76.74v5.8c0 .41-.34.74-.76.74a.75.75 0 0 1-.76-.74zm.76 9.77a.997.997 0 0 1-1.01-.99c0-.55.45-.99 1.01-.99s1.01.44 1.01.99-.45.99-1.01.99"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgErrorTriangle;
